


































































import UserMenu from '@/components/UserMenu.vue';
import SideMenu from '@/components/SideMenu.vue';
import ProfileDialog from '@/components/ProfileDialog.vue';
import RightSideMenu from '@/components/RightSideMenu.vue';
import { Component, Vue } from 'vue-property-decorator';
import Snackbar from '@/components/Snackbar.vue';
import TutorialDialog from '@/components/TutorialDialog.vue';
import { getModule } from 'vuex-module-decorators';
import store from '@/store/store';
import Dialog from '../store/modules/dialog';

const dialogModule = getModule(Dialog, store);

@Component({
  components: {
    SideMenu,
    RightSideMenu,
    UserMenu,
    Snackbar,
    TutorialDialog,
    ProfileDialog
  },
})
export default class DefaultLayout extends Vue {
 
  links = [
    {name: "みんなで翻刻ウィキ", to: "https://wiki.honkoku.org/"},
    {name: "みんなで翻刻サーチ", to: "https://honkoku.dhii.jp/"},
     {name: "くずし字学習支援アプリKuLA", to: "https://kula.honkoku.org"},
     {name: "みんなで翻刻 翻刻テキスト一覧", to: "https://www.dheq.org/honkoku/"}
  ]

  get tutorialDialog() {
    return dialogModule.tutorialDialog;
  }
  set tutorialDialog(value: boolean) {
    dialogModule.toggleTutorialDialog({ open: value });
  }

  query = '';

  toggleTutorialDialog(value: boolean) {
    dialogModule.toggleTutorialDialog({ open: value });
  }

  mounted() {
    this.query = '';
  }
  search() {
    console.log(this.query);
    this.$router.push({
      name: 'search',
      query: { q: this.query.trim(), page: '1' },
    });
  }
}
